export default {
  main: "Primair nummer",
  mobile: "Mobiel nummer",
}
